

//
// Some context: https://stackoverflow.com/questions/43122160/react-router-v4-prevent-transition-with-custom-hook-instead-of-prompt
//

/**
 * 
 * @param dialogKey 
 * @param callback 
 * @returns 
 */
export const getUserConfirmation = (dialogKey: string, callback: any) => {
    // use "message" as Symbol-based key
    //@ts-ignore
    const dialogTrigger = window[Symbol.for(dialogKey)];

    if (dialogTrigger) {
        // pass the callback to delegate
        // to the invoked dialog
        return dialogTrigger(callback);
    }

    // Fallback to allowing navigation
    callback(true);
};
